import {
  BaseQueryFn,
  EndpointBuilder,
  FetchArgs,
  FetchBaseQueryError,
  FetchBaseQueryMeta
} from '@reduxjs/toolkit/query';
import {
  DTWiseListviewResponse,
  FeederWiseListViewResponse,
  HierarchyFilterResponse,
  HierarchyFilterResponseModified,
  NetWorkHierarchyDetailsResponse,
  SubStationWiseListViewResponse,
  TotalConsumptionResponse
} from '../types';
import { Option } from '@/store/hes/types/other';

export const energyAccountingEndpoints = (
  builder: EndpointBuilder<
    BaseQueryFn<
      string | FetchArgs,
      unknown,
      FetchBaseQueryError,
      NonNullable<unknown>,
      FetchBaseQueryMeta
    >,
    string,
    'energyAccountingApi'
  >
) => ({
  getHierarchyFilters: builder.query<HierarchyFilterResponseModified, string>({
    query: (params) => ({
      url: `list_hierarchy${params}`
    }),
    transformResponse: (
      response: HierarchyFilterResponse
    ): HierarchyFilterResponseModified => {
      const zonesSet = new Set<string>();
      const circlesSet = new Set<string>();
      const divisionsSet = new Set<string>();
      const subDivisionsSet = new Set<string>();
      const subStationsSet = new Set<string>();

      response.data.records.forEach((ele) => {
        zonesSet.add(ele?.zone);
        circlesSet.add(ele?.circle);
        divisionsSet.add(ele?.division);
        subDivisionsSet.add(ele?.subdivision);
        subStationsSet.add(ele?.substation_name?.trim());
      });

      const toOptionArray = (set: Set<string>): Option[] =>
        Array.from(set).map((val) => ({ label: val, value: val }));

      return {
        data: {
          records: [
            {
              zones: toOptionArray(zonesSet),
              circles: toOptionArray(circlesSet),
              divisions: toOptionArray(divisionsSet),
              subDivisions: toOptionArray(subDivisionsSet),
              subStations: toOptionArray(subStationsSet)
            }
          ],
          columns: response.data.columns
        },

        error: response.error,
        success: response.success
      };
    }
  }),
  getNetWorkHierarchyDetails: builder.query<
    NetWorkHierarchyDetailsResponse,
    string
  >({
    query: (paramsString) => ({
      url: `/installed_metrics${paramsString}`
    })
  }),
  getTotalEnergyMetrics: builder.query<TotalConsumptionResponse, string>({
    query: (paramsString) => ({
      url: `/overall_consumption_metrics${paramsString}`
    })
  }),
  getSubStationWiseListView: builder.query<
    SubStationWiseListViewResponse,
    string
  >({
    query: (paramString) => ({
      url: `/substation_wise_consumption_metrics${paramString}`
    })
  }),
  getFeederWiseListView: builder.query<FeederWiseListViewResponse, string>({
    query: (paramsString) => ({
      url: `/feeder_wise_consumption_metrics${paramsString}`
    })
  }),
  getDTWiseListView: builder.query<DTWiseListviewResponse, string>({
    query: (paramsString) => ({
      url: `/dtr_wise_consumption_metrics${paramsString}`
    })
  })
});
